import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Typography } from 'rmwc/Typography';
import { Card } from 'rmwc/Card';
import * as api from '../../api/api';
import UserRenderIndividualRoadmapAll from './UserRenderIndividualRoadmapAll';
import UserFlowChartPage from './UserFlowChartPage';
import UserNoFlowChartPage from './UserNoFlowChartPage';

class UserRoadmapsRenderAll extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
            pageView: 'default',
            accessView: '',
        	data: {
                renderData: [],
        		roadmapId: '',
                roadmapName: ''
           	}
    	};
    }

    handleRMView = (roadmapId, roadmapName) => {
        let data = Object.assign({}, this.state.data)
        let pageView = Object.assign({}, this.state.pageView)
        data.roadmapId = roadmapId
        data.roadmapName = roadmapName
        this.setState({data: data})

        api.userFetchRoadmapCompetency(this.props.user.accessToken, roadmapId)
        .then((result) => {
            if(result.status === 'success') {
                console.log(result.status)
                pageView = "flowchart_view"
                this.setState({pageView: pageView})
            }
            else {
                pageView = "no_view"
                this.setState({pageView: pageView})
            }
        })
    }

    handleBackAction = (event) => {
        let pageView = Object.assign({}, this.state.pageView)
        pageView = "default"
        this.setState({pageView: pageView})
    }

    componentDidMount() {
    	let data = Object.assign({}, this.state.data)
        let accessView
    	return api.userRenderAllRoadmaps(this.props.user.accessToken)
    	.then((result) => {
            if(result.status === 'success') {
                accessView = 'access_granted'
                data.renderData = result.data
                this.setState({data: data, accessView: accessView})
            }
            else if (result.status === 'no_access') {
                accessView = 'access_denied'
                this.setState({accessView: accessView})
            }
    	})
    }

    render() {
    	let levelTrackComponent
        let renderComponent
        let accessComponent

        if (this.state.data.renderData.length > 0) {
            let handleRMView = this.handleRMView
            levelTrackComponent = (
                <div>
                    <Grid>
                        {this.state.data.renderData.map(function(roadmapDetails){
                            return (
                                <GridCell span = "6">
                                    <UserRenderIndividualRoadmapAll 
                                        roadmapName = {roadmapDetails.name}
                                        roadmapId = {roadmapDetails.id} 
                                        onhandleRMView = {handleRMView} />
                                </GridCell>
                            )
                        })}
                    </Grid>
                </div>
            )
        }

        if (this.state.accessView === 'access_granted'){
            accessComponent = (
                <div>
                    {levelTrackComponent}
                </div>
            )
        }
        else if (this.state.accessView === 'access_denied'){
            accessComponent = (
                <div>
                    <br />
                    <Card style={{padding: '25px'}}>
                        <Typography use="subtitle2">You will be able to access this section in the coming days.</Typography>
                    </Card>
                </div>
            )
        }

        if (this.state.pageView === "default") {
            renderComponent = (
                <GridCell span="12">
                    <Card style={{padding: '25px'}}>
                        <Typography use="headline5">Micro-Credentials Learning Resources</Typography>
                    </Card>
                    {accessComponent}
                </GridCell>
            )
        }
        else if (this.state.pageView === "flowchart_view") {
            renderComponent = (
                <GridCell span="12">
                <UserFlowChartPage roadmapId = {this.state.data.roadmapId}
                    roadmapName = {this.state.data.roadmapName}
                    handleBackAction = {this.handleBackAction} />
                </GridCell>
            )
        }
        else if (this.state.pageView === "no_view") {
            renderComponent = (
                <GridCell span="12">
                <UserNoFlowChartPage roadmapName = {this.state.data.roadmapName} />
                </GridCell>
            )
        }
        
    	return (
    		<Grid>
                {renderComponent}
            </Grid>
        );
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserRoadmapsRenderAll);




// WEBPACK FOOTER //
// ./src/views/roadmap/UserRoadmapsRenderAll.jsx